import createPlaceholderItems from "../createPlaceholderItems";

const createNewItemsState = ({ offset, limit, itemCount, incomingItems }) => {
  if (offset >= itemCount) {
    return createPlaceholderItems(itemCount);
  }

  const upperOffset = offset + limit;

  if (upperOffset >= itemCount) {
    return [...createPlaceholderItems(offset), ...incomingItems];
  }

  return [
    ...createPlaceholderItems(offset),
    ...incomingItems,
    ...createPlaceholderItems(itemCount - upperOffset, upperOffset)
  ];
};

export default createNewItemsState;
